import React from 'react';
import { Link } from 'gatsby';
import Layout from '../components/layout';
import Ogp from '../components/ogp';
import VisualImage from '../components/visualImage';
import styled from 'styled-components';
import { cardData } from '../data';

const RootIndex: React.FC<{}> = () => {
  const picUrl =
    'https://static.juggling-mstdn.net/media_attachments/files/000/000/020/original/d6d70c0286442d4e.jpg';
  return (
    <Layout>
      <Ogp isRoot={true} />
      <div style={{ background: '#fff' }}>
        <div>
          <VisualImage
            titleData={['集まる', 'ジャグリング']}
            picUrl={picUrl}
            type="primary"
          />
        </div>
        <div className="wrapper">
          <h1 className="section-headline">ぴんとくるくる浄土</h1>
          <div>
            <p>
              「ぴんとくるくる浄土」はピントクルがジャグリングを日々創作しているスタジオ、浄土複合にておこなう小さな発表会です。
              <br />
              大道芸や舞台公演などの「パフォーマー/観客」とは違うあり方で、ジャグリングを身近に感じてもらいたいと思ったことがきっかけ。
              <br />
              道具と触れ合ってきた時間や環境など様々な「ジャグリングライフ」を過ごしてきたジャグラーをお呼びして、5-15分程度のジャグリングを発表します。
              <br />
              また、ピントクルが選んだ道具や雑誌などの展示やトークイベントをおこなうことで、ジャグリングに馴染みがない方でも多角的な視点からジャグリングを体験することができます。
              <br />
              <br />
              ※新型コロナウイルス感染拡大を防ぐため、当イベントは「来場不可」とし、映像配信に変更となりました。
            </p>
          </div>
        </div>
        <div className="wrapper">
          <h2 className="section-headline">Jugglers</h2>
          <ul style={{ listStyle: 'none', paddingLeft: 0 }}></ul>
          <List>
            {cardData.map((data) => (
              <ListItem>
                <CardLink to={data.detailUrl}>
                  <Image src={data.picUrl} />
                  <div>{data.name}</div>
                </CardLink>
              </ListItem>
            ))}
          </List>
        </div>
        <div className="wrapper">
          <h2 className="section-headline">TimeTable</h2>
          <div>
            <div>
              2020/5/9(土),10(日) <br />
              13:00- 酒德波和、染谷樹 <br />
              14:00- 青木直哉 <br />
              16:00- クスヒ、百通りファクトリー <br />
              17:00- トークイベント(9日のみ) <br />
            </div>
          </div>
        </div>
        <div className="wrapper">
          <h2 className="section-headline">Talk Event</h2>
          <div>
            <div>
              5/9(土) 17:00-18:00
              「ジャグリングの30年を振り返る」中西みみず、山下耕平
            </div>
          </div>
        </div>
        <div className="wrapper">
          <h2 className="section-headline">Venue</h2>
          <p>
            <a href="https://jdfkg.tumblr.com" target="_blank">
              浄土複合
            </a>
          </p>
          <p>
            ※当イベントは「来場不可」となりますので会場にお越しいただくことはできません。
            イベント後にテキストや動画にて発表の様子を公開致します。
            <br />
            詳細は<Link to="/statement">こちら</Link>をご覧ください。
          </p>
        </div>
        <div className="wrapper">
          <h2 className="section-headline">Live</h2>
          <p>
            配信は
            <a
              href="https://www.youtube.com/watch?v=48qy4-BjK7c"
              target="_blank"
            >
              こちら
            </a>
          </p>
        </div>
        {/* <div className="wrapper">
          <h2 className="section-headline">Credit</h2>
          <p>
            <div>照明：渡辺佳奈</div>
            <div>写真撮影：染谷樹</div>
            <div>映像撮影：中谷利明</div>
            <div>ウェブ制作：中西みみず</div>
            <div>協力：浄土複合</div>
            <div>企画：Juggling Unit ピントクル</div>
          </p>
        </div> */}
      </div>
    </Layout>
  );
};

export default RootIndex;

const List = styled.ul`
  display: flex;
  flex-direction: row;
  list-style: none;
  padding: 0;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const ListItem = styled.li`
  flex-basis: 49%;
  margin-bottom: 20px;
`;

const CardLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;
`;

const Image = styled.img`
  width: 100%;
  margin-bottom: 10px;
`;
